import React from "react";
import data from "./../../data/page";

const Footer = () => {
  const { footer } = data;

  return (
    <footer role="contentinfo">
      <div className="mmmTapesWalmart-footer">
        <p id="mmmTapesWalmart-disclaimer">{footer.disclaimer}</p>
        <div className="mmmTapesWalmart-copyright">
          <img alt="3m logo" src={footer.mmmLogo} />
          <p id="mmmTapesWalmart-copy">{footer.copy}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
